import {updateBlockReason} from './app/pwa-update.mjs';
// ChunkErrorBoundary.tsx
import React from "react";
import i18n from "./_mesomb/i18n";
import { KTIcon } from './_mesomb/helpers/components/KTIcon.tsx';

interface State {
  hasChunkError: boolean;
  reloadBlocked?: boolean;
}

export class ChunkErrorBoundary extends React.Component<
  React.PropsWithChildren,
  State
> {
  state: State = {
    hasChunkError: false,
  };

  private static isChunkLoadingError(error: unknown): boolean {
    const message = error instanceof Error ? error.message : String(error);

    return (
      message.includes("Failed to fetch dynamically imported module") ||
      message.includes("Importing a module script failed") ||
      message.includes("Loading chunk") ||
      message.includes("ChunkLoadError")
    );
  }

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasChunkError: ChunkErrorBoundary.isChunkLoadingError(error),
    };
  }

  componentDidCatch(error: unknown) {
    if (!ChunkErrorBoundary.isChunkLoadingError(error)) {
      throw error;
    }
  }

  handleReload = () => {
    if (updateBlockReason()) {this.setState({reloadBlocked:true});return;}
    window.location.reload();
  };

  render() {
    if (this.state.hasChunkError) {
      return (
        <div className='d-flex flex-column flex-root bg-body'>
          <div className='d-flex flex-column flex-center flex-column-fluid p-6 p-lg-10'>
            <div className='card border-0 shadow-sm w-100 mw-550px'>
              <div className='card-body p-8 p-lg-12 text-center'>
                <div className='d-inline-flex align-items-center justify-content-center w-70px h-70px rounded-circle bg-light-primary mb-6'>
                  <KTIcon iconName='arrows-circle' className='fs-1 text-primary' />
                </div>

                <h1 className='text-gray-900 fw-bolder fs-2x mb-3'>
                  {i18n.t("Update available")}
                </h1>

                <p className='text-gray-600 fw-semibold fs-5 mb-8'>
                  {i18n.t("A new version is ready. Refresh now to keep using the latest improvements.")}
                </p>

                {this.state.reloadBlocked && <p role='alert'>{i18n.t('Finish the current operation and check its status before updating. An update will not restart your payment.')}</p>}
                <div className='d-flex justify-content-center'>
                  <button
                    type='button'
                    className='btn btn-primary px-8 py-3'
                    onClick={this.handleReload}
                  >
                    <KTIcon iconName='arrows-circle' className='fs-3 me-2' />
                    {i18n.t("Refresh now")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
